import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Role } from '../shared/models';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent {
  @Input()
  set roles(roles: Role[]) {
    this.dispatchRoles(roles);
  }
  @Input() loading: boolean;
  @Output() deleteRole: EventEmitter<any> = new EventEmitter();
  @Output() roleSelected: EventEmitter<any> = new EventEmitter();

  companyRoles = [];
  alcmeonRoles = [];

  private dispatchRoles(roles: Role[]) {
    this.companyRoles = [];
    this.alcmeonRoles = [];
    (roles || []).forEach((role: Role) => {
      if (role.is_static) {
        this.alcmeonRoles.push(role);
      } else {
        this.companyRoles.push(role);
      }
    });
  }
}
